import { render, staticRenderFns } from "./Moderasi.vue?vue&type=template&id=283fd7ba"
import script from "./Moderasi.vue?vue&type=script&lang=js"
export * from "./Moderasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports